import RollPointGameContentSlotCardItem from './Item';
import { RollPointGameContentSlotCardProps } from './props';
import styles from './styles.module.scss';

export default function RollPointGameContentSlotCard({
  column,
}: RollPointGameContentSlotCardProps) {
  return (
    <div
      className={`${styles.card} ${styles[`card--${process.env.NEXT_PUBLIC_TENANT_ID}`]}`}
      style={{
        //@ts-ignore
        '--bg-image': ['ice', 'gli'].includes(process.env.NEXT_PUBLIC_TENANT_ID)
          ? `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/bg-slot.png)`
          : 'unset',
      }}
    >
      <RollPointGameContentSlotCardItem column={column} />
    </div>
  );
}
